function initBoldFullScreenNavigation() {
    // Toggle Navigation
    document
        .querySelectorAll('[data-navigation-toggle="toggle"]')
        .forEach((toggleBtn) => {
            toggleBtn.addEventListener('click', () => {
                const navStatusEl = document.querySelector(
                    '[data-navigation-status]'
                )
                if (!navStatusEl) return
                if (
                    navStatusEl.getAttribute('data-navigation-status') ===
                    'not-active'
                ) {
                    navStatusEl.setAttribute('data-navigation-status', 'active')
                    window.lenis.stop()
                } else {
                    navStatusEl.setAttribute(
                        'data-navigation-status',
                        'not-active'
                    )
                    window.lenis.start()
                }
            })
        })

    // Close Navigation
    document
        .querySelectorAll('[data-navigation-toggle="close"]')
        .forEach((closeBtn) => {
            closeBtn.addEventListener('click', () => {
                const navStatusEl = document.querySelector(
                    '[data-navigation-status]'
                )
                if (!navStatusEl) return
                navStatusEl.setAttribute('data-navigation-status', 'not-active')
                window.lenis.start()
            })
        })

    // Key ESC - Close Navigation
    document.addEventListener('keydown', (e) => {
        if (e.keyCode === 27) {
            const navStatusEl = document.querySelector(
                '[data-navigation-status]'
            )
            if (!navStatusEl) return
            if (
                navStatusEl.getAttribute('data-navigation-status') === 'active'
            ) {
                navStatusEl.setAttribute('data-navigation-status', 'not-active')
                window.lenis.start()
            }
        }
    })
}

// Initialize Bold Full Screen Navigation
document.addEventListener('DOMContentLoaded', function () {
    initBoldFullScreenNavigation()
})
